import {
  FastForward,
  FolderPlus,
  Lightbulb,
  Mic,
  NotebookPen,
  ClipboardCheck,
} from 'lucide-react';
import type { OnboardingNudgeKey } from '@wundo/shared/onboardingNudge.ts';

/**
 * The picture on a nudge card.
 *
 * The same drawings the quick actions use for the same kinds of help, so the
 * card and the pill under it never show two pictures of one thing.
 */
export function chatNudgeIcon(key: OnboardingNudgeKey) {
  switch (key) {
    case 'plan_first_meeting':
      return <NotebookPen aria-hidden='true' />;
    case 'try_library_roleplay':
    case 'rehearse_this_meeting':
      return <FastForward aria-hidden='true' />;
    case 'ask_conversation_tips':
      return <Lightbulb aria-hidden='true' />;
    case 'enable_notetaker':
      return <Mic aria-hidden='true' />;
    case 'ask_meeting_feedback':
      return <ClipboardCheck aria-hidden='true' />;
    case 'upload_person_document':
      return <FolderPlus aria-hidden='true' />;
  }
}
